var _path, _path2, _circle, _circle2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShoppingCartIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 178,
    viewBox: "0 0 231 178",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.251 77.1892L139.572 54.8958C140.906 53.4321 143.328 54.5899 143.027 56.5473L141.222 68.2696C141.031 69.5154 142.025 70.6258 143.284 70.572L154.162 70.1073C155.944 70.0312 156.927 72.1496 155.718 73.4611L134.827 96.1217C133.416 97.6523 130.897 96.2772 131.421 94.2625L134.481 82.5025C134.82 81.1987 133.799 79.9393 132.453 80.001L120.82 80.5344C119.041 80.616 118.051 78.5057 119.251 77.1892Z",
    fill: "url(#paint0_linear_109_41)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H34.237C35.8999 8 37.3894 9.02884 37.978 10.5841L48.3546 38M84.5 133.5L77.498 115M48.3546 38H218.063C220.761 38 222.685 40.6151 221.882 43.1903L200.376 112.19C199.855 113.862 198.308 115 196.557 115H77.498M48.3546 38L77.498 115",
    stroke: "black",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 89.5,
    cy: 153.5,
    r: 16.5,
    stroke: "black",
    strokeWidth: 16
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 176.5,
    cy: 153.5,
    r: 16.5,
    stroke: "black",
    strokeWidth: 16
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89 137H179",
    stroke: "black",
    strokeWidth: 16,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_109_41",
    x1: 141.394,
    y1: 54.2903,
    x2: 116.533,
    y2: 68.4644,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E84126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5ED4C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCartIcon);
export default __webpack_public_path__ + "static/media/shopping-cart-icon.77676440a22aaec40d6fdaf3c135d1c4.svg";
export { ForwardRef as ReactComponent };